import React, { FC } from 'react';
import { DSIconElement } from '@saucelabs/ds-icons';
import { Typography } from '@saucelabs/ds-typography';
import { Tag } from '@saucelabs/ds-tag';

export const GetStartedCard: FC<GetStartedCardProps> = (props) => {
  const {
    href,
    title,
    tags,
    icon: Icon,
  } = props;
  return (
    <a
      className="hover:no-underline"
      href={href}
      rel="noreferrer"
      target="_blank"
    >
      <div className="flex p-2 border border-solid border-gray-400 rounded hover:bg-blue-50 transition-colors">
        <div className="pr-2">
          <Icon
            height="40"
            width="40"
          />
        </div>
        <div>
          <Typography
            className="text-high-emphasis w-full mt-0 mb-2"
            component="div"
            disableSpacing
            disableTextColor
            variant="heading-4"
          >
            {title}
          </Typography>

          {tags.map((tag) => (
            <Tag
              key={tag}
              className="mr-0.5 mb-0.5 font-normal"
            >
              {tag}
            </Tag>
          ))}
        </div>
      </div>
    </a>
  );
};

export interface GetStartedCardProps {
  href: string;
  icon: DSIconElement;
  title: string;
  tags: string[];
}
